module.exports = __webpack_public_path__ + "static/img/公司简介.c40b66a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/about_article/公司简介.png
// module id = 635
// module chunks = 1